import throttle from "just-throttle";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import OverlayMenu from "@lib/beskar-overlay-menu/bskr-overlay-menu.mjs";
import { initStickyButtons } from "./components/sticky-buttons.js";
import { initModals } from "./components/modal.js";
import { initSonataForm } from "./components/sonata-form.js";

function initLenisScroll() {
  const lenis = new Lenis({
    prevent: function (element) {
      return element.classList.contains("no-lenis");
    },
  });
  window.lenisInstance = lenis;

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  return { lenis, addEventListener, gsapTicker: gsap.ticker };
}

let isHeaderHidden = false;

function toggleHeaderOnMenu(
  header,
  args = { duration: 0.5, ease: "power4.out" }
) {
  document.body.classList.toggle("on-menu-opened");
  const isHidden = toggleHeader(header, args);
  gsap.to(header, {
    yPercent: isHidden ? -100 : 0,
    ...args,
  });
}

function showHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  gsap.to(header, {
    yPercent: 0,
    ...args,
  });
}

function hideHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  gsap.to(header, {
    yPercent: -100,
    ...args,
  });
}

function toggleHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  isHeaderHidden = !isHeaderHidden;
  !isHeaderHidden ? hideHeader(header, args) : showHeader(header, args);
  return isHeaderHidden;
}

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(gsap.ScrollTrigger);

  const isDesktop = window.innerWidth >= 1024;

  let lenis = isDesktop ? initLenisScroll().lenis : null;

  const header = document.getElementById("header");
  const overlayMenu = new OverlayMenu("main", { options: { duration: 1 } });

  initStickyButtons();
  initModals();
  initSonataForm();

  if (overlayMenu) {
    overlayMenu.addEvent(
      "onOpen",
      throttle(() => {
        lenis?.stop();
        toggleHeaderOnMenu(header);
      }, 10)
    );

    overlayMenu.addEvent(
      "onClosed",
      throttle(() => {
        lenis?.start();
        toggleHeaderOnMenu(header);
      }, 10)
    );
  }

  window.showHeader = () => showHeader(header);
  window.hideHeader = () => hideHeader(header);
  window.toggleHeader = () => toggleHeader(header);

  // Sticky header: add/remove is-sticky class based on scroll position
  const updateStickyClass = () => {
    header.classList.toggle("is-sticky", window.scrollY > 0);
  };
  updateStickyClass();
  if (lenis) {
    lenis.on("scroll", updateStickyClass);
  } else {
    window.addEventListener("scroll", updateStickyClass, { passive: true });
  }

  // Language Selector
  const langSelector = document.querySelectorAll(".language-selector");

  if (langSelector) {
    langSelector.forEach((selector) => {
      selector.addEventListener("change", function () {
        window.location.href = this.value;
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (process.env.NODE_ENV === "development") {
    console.log("Development mode enabled.");
  }
});
